module.exports = __webpack_public_path__ + "img/xin-biao.bdef00cc.png";